import {type ClassValue, clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Converts bare http/https URLs in a string into markdown link syntax so
// react-markdown renders them as clickable anchors. Skips URLs that are
// already inside markdown link syntax `](url)` or autolink syntax `<url>`.
export function linkifyUrls(text: string): string {
  if (!text) return text;
  return text.replace(/(?<![(<])\bhttps?:\/\/[^\s<>"'`)\]]+/g, (url) => {
    const cleaned = url.replace(/[.,;:!?]+$/, '');
    const trailing = url.slice(cleaned.length);
    return `[${cleaned}](${cleaned})${trailing}`;
  });
}
